import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { de } from "./locales/de";
import { en } from "./locales/en";
const resources = { de, en };

i18n.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources,
		fallbackLng: "de",
		supportedLngs: ["de", "en"],
		nonExplicitSupportedLngs: true,
		load: "languageOnly",
		defaultNS: "common",
		ns: ["common", "tree", "configs", "validation", "errors"],
		interpolation: {
			escapeValue: false,
		},
		detection: {
			order: ["localStorage", "navigator"],
			caches: ["localStorage"],
			lookupLocalStorage: "i18nextLng",
		},
		react: {
			useSuspense: false,
		},
	});

export default i18n;
